<template>
    <div>
        <b-button
            v-b-modal.changePasswordModal
            variant="outline-secondary"
            v-b-tooltip.hover.left
            title="Cambiar contraseña"
        >
            <b-icon icon="shield-lock" font-scale="1"></b-icon>
        </b-button>

        <!-- Modal -->
        <b-modal id="changePasswordModal" title="Cambiar contraseña" class="" size="sm" centered
                 header-bg-variant="dark" v-model="modalShow" hide-footer>

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>

            </template>

            <UpdatePasswordForm/>

        </b-modal>
    </div>
</template>
<script>
import UpdatePasswordForm from "@/components/home/changePassword/updatePasswordForm.vue";

export default {
    name: 'UpdatePassword',

    data() {
        return {
            modalShow: false
        }
    },

    components: {
        UpdatePasswordForm,
    },

    methods:{
        openModal() {
            this.modalShow = true;
        },

        closeModal() {
            this.modalShow = false;
        },
    }

}
</script>
<style scoped>
.card {
    position: relative;
    width: auto;
    height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: end;
    padding: 12px;
    gap: 12px;
    border-radius: 8px;
    cursor: pointer;
    margin: 20px;
}
</style>
